import React, { useEffect, useState } from "react";
import { Timer } from "@phosphor-icons/react";
import { toast } from "sonner";
import { fetchStockWatchSettings, updateStockWatchSettings } from "../lib/api";
import { formatApiError } from "../lib/auth";

export function StockWatchInterval() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchStockWatchSettings().then(setSettings).catch(() => {});
  }, []);

  const choose = async (m) => {
    if (m === settings?.interval_minutes) return;
    setSaving(true);
    try {
      setSettings(await updateStockWatchSettings(m));
      toast.success(`Revisión automática cada ${m} min`);
    } catch (e) {
      toast.error(formatApiError(e) || "No se pudo guardar");
    }
    setSaving(false);
  };

  if (!settings) return null;
  const next = settings.next_run_at ? new Date(settings.next_run_at).toLocaleTimeString() : "—";

  return (
    <div className="border-2 border-zinc-950 p-4 bg-white" data-testid="stock-watch-interval">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#002FA7] mb-3 flex items-center gap-1">
        <Timer size={14} weight="bold" /> Revisar cada
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
        {settings.allowed_intervals.map((m) => (
          <button
            key={m}
            onClick={() => choose(m)}
            disabled={saving}
            data-testid={`stock-watch-interval-${m}`}
            className={`h-10 font-mono text-sm font-bold uppercase border-2 transition-colors duration-150 ${
              settings.interval_minutes === m
                ? "bg-[#002FA7] border-[#002FA7] text-white"
                : "bg-white border-zinc-300 text-zinc-800 hover:border-zinc-950"
            }`}
          >
            {m} min
          </button>
        ))}
      </div>
      <p className="text-xs text-zinc-500 mt-2 font-mono" data-testid="stock-watch-next-run">
        Actual: cada {settings.interval_minutes} min · Próxima revisión: {next}
      </p>
    </div>
  );
}
